import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";

const IndexComponent = lazy(() =>
  import("@/modules/profile/profile").then((module) => ({
    default: module.Profile,
  }))
);

export const Route = createFileRoute("/(auth)/_headed/account")({
  component: IndexComponent,
});
